import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqUploadDocumentsMutation, type ResUploadDocumentsMutation } from './types'

/**
 *
 * @description errors
 *
 * {
 *   "code": "413",
 *   "description": "status request entity too large: limit 20MB",
 * }
 */
export const uploadDocumentsMutation: MutationOptions<ResUploadDocumentsMutation, unknown, ReqUploadDocumentsMutation> =
  {
    mutationFn: (payload) => w.formData(payload).url(API_ENDPOINTS.business.v1.ocr.index).post().json(),
  }
